<template>
  <div class="user-center">
    <div class="top">
      <Top :topData="topData" @openPayMent="openPayMent"/>
    </div>
    <!-- 图表 -->
    <div class="charts">
      <!-- <a-row :gutter="20">
        <a-col :span="24"> -->
          <!-- <a-card :bordered="false"> -->
            <div class="flex-box" v-if="showCharts">
              <a-badge class="data-title" status="processing" :dot="true" text="证书录入情况" />
              <div style="margin-top: 10px">
                <a-radio-group  v-model="chartparam.type" @change="typeChange">
                  <a-radio-button value="cert">成品数量</a-radio-button>
                  <a-radio-button value="keyPieceCert">关键件数量</a-radio-button>
                  <!-- <a-radio-button value="report">报告数量</a-radio-button> -->
                </a-radio-group>
                <a-radio-group @change="expireChange" v-model="chartparam.date" style="float: right;margin-right: 10px;">
                  <a-radio-button value="week">本周</a-radio-button>
                  <a-radio-button value="month">本月</a-radio-button>
                  <a-radio-button value="year">本年</a-radio-button>
                </a-radio-group>
              </div>
              <ve-histogram ref="histogram" :legend-visible="false" :data="chartData1" :yAxis="yAxis"></ve-histogram>
            </div>
            <div class="flex-box" v-if="dataRangeCharts" style="border-left:1px dashed #ccc;min-height:400px;padding-left:20px;overflow: hidden;overflow-y: auto;">
              <a-badge class="data-title" status="processing" :dot="true" text="各事业部证书分布" />
              <div id="main" style="width: 100%;min-height:400px;"></div>
              <!-- <h2 slot="title" style="font-weight:bold;font-size:16px;height:32px;"><span v-if="chartparam.type=='cert'">证书</span><span v-if="chartparam.type=='report'">报告</span>类别排名</h2>
              <a-row :gutter="20" v-for="(item,index) in rightData" :key="item.deptId" style="margin-top:7px;">
                <a-col class="gutter-row" :span="3">
                  <div class="gutter-box" style="font-size:28px;border-radius:50%;border:2px solid #333;width:45px;height:45px;text-align:center">{{index+1}}</div>
                </a-col>
                <a-col class="gutter-row" :span="16">
                  <div class="gutter-box" style="text-align:right;line-height:40px;">{{item.name}}</div>
                </a-col>
                <a-col class="gutter-row" :span="5">
                  <div class="gutter-box" style="line-height:40px;">{{item.num}} 份</div>
                </a-col>
              </a-row>
              <h2 slot="title" style="font-weight:bold;font-size:16px;height:32px;margin-top: 30px">事业部<span v-if="chartparam.type=='cert'">证书</span><span v-if="chartparam.type=='report'">报告</span>数量</h2>
              <a-row :gutter="20" v-for="(item,index) in rightBot" :key="index" style="margin-top:7px;">
               <a-col class="gutter-row" :span="3">
                  <div class="gutter-box" style="font-size:28px;border-radius:50%;border:2px solid #333;width:45px;height:45px;text-align:center">{{index+1}}</div>
                </a-col>
                <a-col class="gutter-row" :span="16">
                  <div class="gutter-box" style="text-align:right;line-height:40px;">{{item.name}}</div>
                </a-col>
                <a-col class="gutter-row" :span="5">
                  <div class="gutter-box" style="line-height:40px;">{{item.num}} 份</div>
                </a-col>
              </a-row> -->
            </div>
          <!-- </a-card>
        </a-col> -->
        <!-- <a-col :span="8">
          <a-card :bordered="false">
            <h2 slot="title" style="font-weight:bold;font-size:16px;height:32px;">证书类别排名</h2>
            <a-row :gutter="20" v-for="(item,index) in rightData" :key="item.deptId">
              <a-col class="gutter-row" :span="3">
                <div class="gutter-box" style="font-size:28px;">{{index+1}}</div>
              </a-col>
              <a-col class="gutter-row" :span="16">
                <div class="gutter-box" style="text-align:right;line-height:40px;">{{item.name}}</div>
              </a-col>
              <a-col class="gutter-row" :span="5">
                <div class="gutter-box" style="line-height:40px;">{{item.num}}份</div>
              </a-col>
            </a-row>
          </a-card>
        </a-col> -->
      <!-- </a-row> -->
    </div>

    <!-- 资讯 -->
    <!-- <div class="news">
      <div class="news-top">
        <a-button-group style="margin-bottom: 15px;">
          <a-button @click="toggleType('')" :type="messageParams.classify === '' ? 'primary' : ''">全部消息</a-button>
          <a-button @click="toggleType('WARNING')" :type="messageParams.classify === 'WARNING' ? 'primary' : ''">预警消息</a-button>
          <a-button @click="toggleType('INFORMATION')" :type="messageParams.classify === 'INFORMATION' ? 'primary' : ''">行业资讯</a-button>
        </a-button-group>

        <a-button type="link" class="look-more"><router-link to="/user/message">查看全部</router-link></a-button>
      </div>

      <a-divider style="margin: 0;"></a-divider>

      <a-list :dataSource="data">
        <a-list-item slot="renderItem" slot-scope="item, index">
          <a-list-item-meta>
            <router-link slot="title" to="/"><span style="margin-right:15px;">{{index + 1}}</span><span>{{item.title}}</span></router-link>
          </a-list-item-meta>
          <div style="padding-right: 15px;">{{item.createdAt | moment('YYYY/MM/DD')}}</div>
        </a-list-item>
      </a-list>
    </div> -->
    <Payment :maskClosable="false" :closable="false" ref="payData" @paySuccess="paySuccess"/>
    <a-modal class="info-modal" :width="450" v-model="infoVisible" :footer="false">
      <p class="title"><a-icon type="mail" style="color:#3385FF;margin-right: 10px;"/>来自品牌商的邀请</p>
      <p><span class="company-name">{{companyName}}</span> 正在邀请您协同完成一致性自检，</p>
      <p>接受邀请完成相应功能激活~</p>
      <p style="text-align: right; margin: 20px 0 0 0;"><a-button @click="refuseAction" style="margin-right: 10px">拒绝</a-button><a-button type="primary" @click="hideModal">接受邀请</a-button></p>
    </a-modal>
  </div>
</template>

<script>
import { searchHasMessage, buttonReply } from '@/api/consistency'

import Top from "@/components/users/companyCenter/Top.vue";
import Payment from "@/components/users/companyCenter/Payment.vue";
import { 
  queryMessage,
  agencySummary,
  agencyClassifiedStatistic,
  agencyExpireMap
} from '@/api/user'
import { 
  enterpriseTop,
  enterpriseRight,
  enterpriseBottom,
  enterpriseRightBot
} from '@/api/userCenter'
export default {
  components: { Top,Payment },
  data() {
    return {
      yAxis:[
          {
            type:'value',
            minInterval:1  //y轴整数
          }
        ],
      chartparam:{
        date:'week',
        type:'cert',
      },
      showCharts: false,
      chartData: {
        columns: ['name', 'presentationCount'],
        rows: []
      },
      chartData1: {
        columns: ['日期','数量'],
        rows: []
      },
      data: [],
      rightData: [],
      rightBot: [],
      topData:{},
      messageParams: {
        classify: ''
      },
      expireDate:null,
      waringVisible:false,
      dataRangeCharts: true,
      infoVisible: false,
      companyName: '',
      infoId: ''
    };
  },

  mounted() {
    this.$nextTick( _ => {
      this.showCharts = true
      setTimeout(() => {
        if(this.$refs.histogram.echarts.resize) {
          // this.$refs.pie.echarts.resize()
          this.$refs.histogram.echarts.resize()
        }
      }, 100);
    })
    // this.queryMessage()
    this.getAgencySummary()
    // this.getagencyClassifiedStatistic()
    this.getagencyExpireMap(this.chartparam)
    // this.getenterpriseRight(this.chartparam)
    this.getEnterpriseRightBot()
    // this.myEcharts();
    this.searchHasMessage();
  },

  methods: {
    searchHasMessage() {
      searchHasMessage()
        .then(res => {
          if (res && res.type) {
            if (res.type == '2') {
                this.infoVisible = true;
                this.companyName = res.name;
                this.infoId = res.id;
            }
          }
        })
        .catch(error => {
          console.log(error);
        })
    },
    refuseAction() {
      this.buttonReply(this.infoId, false);
    },
    hideModal() {
      this.buttonReply(this.infoId, true);
    },
    buttonReply(id, reply) {
      buttonReply(id, reply)
        .then(res => {
          this.infoVisible = false;
          location.reload();
        })
        .catch(error => {
          console.log(error);
        })
    },
    /**
     * 充值成功更新信息
     */
    paySuccess(){
      this.getAgencySummary()
    },
    /**
     * 打开支付弹出框
     */
    openPayMent(value){
      this.$refs.payData.expireDate = value
      this.$refs.payData.visible = true
    },
    toggleType(state) {
      this.messageParams.classify = state
      this.queryMessage()
    },
    expireChange(e){
      this.chartparam.date = e.target.value;
      this.getagencyExpireMap(this.chartparam);
    },
    typeChange(e){
      this.chartparam.type = e.target.value;
      this.getagencyExpireMap(this.chartparam);
    },
    async getagencyExpireMap(params) {
      try {
        let data = await enterpriseBottom(params)
        let newDatas=[]
        // 将 keys值更改为符合的
        data.map(item => {
          let keyMap ={'date':'日期','num':'数量'}
          let objs = Object.keys(item).reduce((newData, key) => {
            let newKey = keyMap[key] || key
            newData[newKey] = item[key]
            return newData
          }, {})
          newDatas.push(objs)
        })
        this.chartData1.rows = newDatas
      } catch (error) {
        
      }
    },
    async getenterpriseRight(params) {
      try {
        let data = await enterpriseRight(params)
        this.rightData = data.slice(0,6);
      } catch (error) {
        
      }
    },
    getEnterpriseRightBot() {
      enterpriseRightBot()
        .then(res => {
          var rightData = [];
          var rangeData = [];
          var keyData = [];
          var certData = [];
          if (res.length > 0) {
            rightData = res;
            rightData.map(i => {
              certData.push(i.certNum);
              keyData.push(i.keyNum);
              rangeData.push(i.name);
            })
            var myChart = this.$echarts.init(document.getElementById('main'));
            var option = {
              color: ['#3db9dc', '#5cd580'],
                tooltip: {
                    trigger: 'axis',
                    axisPointer: {
                        type: 'shadow'
                    }
                },
                legend: {
                    data: ['成品', '关键件']
                },
                grid: {
                    left: '3%',
                    right: '4%',
                    bottom: '3%',
                    containLabel: true
                },
                xAxis: [
                    {
                        type: 'value',
                        splitLine: {
                        show: true,
                        lineStyle: {
                            color: '#c1c1c1',
                            width: 1,
                            type: 'dashed'
                          }
                        }
                    }
                ],
                yAxis: [
                    {
                        type: 'category',
                        axisTick: {
                            show: false
                        },
                        data: rangeData
                    }
                ],
                series: [
                    {
                        name: '成品',
                        type: 'bar',
                        barGap: 0,
                        label: {
                            show: true,
                            position: 'inside'
                        },
                        data: certData
                    },
                    {
                        name: '关键件',
                        type: 'bar',
                        stack: '总量',
                        label: {
                            show: true
                        },
                        data: keyData
                    }
                ]
            };
            myChart.setOption(option);
            this.dataRangeCharts = true;
          } else {
            this.dataRangeCharts = false;
          }
        })
        .catch(error => {
          console.log(error);
        })
    },
    async getagencyClassifiedStatistic() {
      try {
        let data = await agencyClassifiedStatistic()
          this.chartData.rows = data
      } catch (error) {
        
      }
    },

    async getAgencySummary() {
      try {
        let data = await enterpriseTop()
          this.topData = data
          this.expireDate = data.expireDate
          localStorage.setItem("expireDate",this.expireDate)
          this.$store.commit('SET_EXPIRE_Date',this.expireDate)
      } catch (error) {
        
      }
    },

    // 查询消息列表
    async queryMessage() {
      try {
        let data = await queryMessage(this.messageParams)
        if(data && data.content) {
          this.data = data.content
        }
      } catch (error) {
        
      }
    },
    warning(){
      // this.waringVisible = true
      // setTimeout(()=>{
      //   this.waringVisible = false
      // },2000)
      this.$warning({
        title: '剩余天数仅有0天，请您充值后访问',
      });
    }
  },
  watch: {
    // expireDate(val){
    //   if(val <=0){
    //     this.warning()
    //   }
    // }
  },
};
</script>

<style lang="less" scoped>
.info-modal {
  p {
    font-size: 12px;
    margin-bottom: 10px;
    overflow: hidden;
  }
  .title {
    font-size: 16px;
    margin-bottom: 20px;
  }
  .company-name {
    color: #3385FF;
    font-size: 14px;
  }
}
.data-title {
  font-weight: 500;
}
.user-center {
  min-height: 100%;
  padding-bottom: 15px;
  background-color: #fff;
  .company{
    height: 40px;
    font-size: 30px;
    .num{
      width: 40px;
      height: 40px;
      border: 1px solid #333;
      font-size: 30px;
      font-weight: bold;
      border-radius: 100%;
      display: inline-block;
      text-align: center;
      line-height: 36px;
      margin-right: 30px;
    }
    .name{
      font-size: 20px;
      display: inline-block;
      line-height: 40px
      // float: right;
    }
  }
  .top {
    padding: 10px 15px 0;
    margin-bottom: 15px;

    .top-username {
      padding: 10px 0;
      font-size: 16px;
      padding: 15px 0 5px;
      border-bottom: 1px solid #eee;
      margin-bottom: 12px;
      color: #000;
    }
  }

  .charts {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    padding: 0 15px;
    display: flex;
    align-items: center;
    .flex-box {
      flex: 1;
    }
    // .ant-card {
    //   box-shadow: 0px 0px 8px 0px rgba(0,0,0,.1);
    //   border-radius: 4px;
    // }
  }

  .news {
    padding: 30px 15px 0;
    background-color: #fff;
    border: 1px solid #eee;
    margin: 15px 15px 0;
    box-shadow: 0px 0px 8px 0px rgba(0,0,0,.1);
    border-radius: 4px;

    .news-top {
      display: flex;
      align-items: bottom;
      justify-content: space-between;
    }
  }
}
</style>
